module.exports = __webpack_public_path__ + "img/06-full.ac8f2fe7.jpeg";